// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1xZhv_MOtzTYkHv56Z2-Y-"};